<template>
  <div class="min-h-screen">
    <request-training
      :showRequestTraining="showRequestTraining"
      @close="showRequestTraining = false"
      :isSubmitted="isSubmitted"
      :trainingRequestCallback="trainingRequestCallback"
      :approvers="approvers"
      :refresh="refresh"
    ></request-training>

    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">Training Requests</p>
      </div>
      <div
        class="flex items-center justify-between my-2 mb-3 pr-3 w-full overflow-x-auto gap-5"
      >
        <div class="flex items-left">
          <el-pagination
            background
            @size-change="handleSizeChange"
            :page-sizes="pageSizes"
            :page-index="pageIndex"
            :page-size="pageSize"
            layout="sizes"
            :total="pendingTrainings.length"
            style="border-radius: 0 !important"
          >
          </el-pagination>

          <!-- search -->
          <input
            v-model="searchInput2"
            type="search"
            placeholder="Start typing to search..."
            class="bg-gray-200 w-52 rounded-md py-2 h-10"
          />
          <!-- search -->
        </div>

        <div>
          <button
            @click="showRequestTraining = true"
            class="bg-primary text-white rounded-full text-sm h-10"
          >
            Request Training
          </button>
        </div>
      </div>
      <div class="" v-if="pendingTrainings.length && !loading">
        <div>
          <ve-table
            v-if="searchInput2"
            :columns="columns"
            :table-data="pendingTrainings"
            sort-order="asc"
          />
          <ve-table
            :columns="columns"
            :tableData="pendingTrainings"

            v-if="!searchInput2.length"
          >
<!--            :event-custom-option="eventCustomOption"-->
          </ve-table>
          <p
            v-if="searchInput2.length && pendingTrainings.length === 0"
            class="text-center py-3"
          >
            No results
          </p>
          <!-- Pagination -->
          <div class="table-pagination text-center mt-2">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
          <!-- Pagination -->
        </div>
      </div>
      <p v-else class="text-center p-3 text-sm w-full bg-gray-100">
        No Training found
      </p>
    </div>

    <transition name="fade">
      <div
        v-if="loading"
        class="inset-0 absolute z-50 bg-black bg-opacity-10 w-full"
      >
        <loader class="center-h-v" />
      </div>
    </transition>

    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">Training History</p>
      </div>

      <div
        class="flex items-center justify-between my-2 mb-3 pr-3 w-full overflow-x-auto gap-5"
      >
        <div class="flex items-left">
          <el-pagination
            background
            @size-change="handleSizeChange"
            :page-sizes="pageSizes"
            :page-index="pageIndex"
            :page-size="pageSize"
            layout="sizes"
            :total="filteredTrainingHistories.length"
            style="border-radius: 0 !important"
          >
          </el-pagination>

          <!-- search -->
          <input
            v-model="searchInput2"
            type="search"
            placeholder="Start typing to search..."
            class="bg-gray-200 w-52 py-1 rounded-md"
          />
          <!-- search -->
        </div>
      </div>
      <div class="">
        <el-tabs
          type="border-card"
          v-model="currentTab"
          @tab-click="(e) => setTab(e)"
        >
          <el-tab-pane
            v-for="(tab, index) in tabs"
            :key="index"
            :label="tab.name"
            :name="tab.name"
          >
            <div class="" v-if="filteredTrainingHistories.length && !loading">
              <div>
                <ve-table
                  v-if="searchInput2"
                  :columns="columns"
                  :table-data="filteredTrainingHistories"

                  sort-order="asc"
                />

                <ve-table
                  :columns="columns"
                  :tableData="filteredTrainingHistories"

                  v-if="!searchInput2.length"
                >
                </ve-table>

                <p
                  v-if="
                    searchInput2.length &&
                    filteredTrainingHistories.length === 0
                  "
                  class="text-center py-3"
                >
                  No results
                </p>
                <!-- Pagination -->
                <div class="table-pagination text-center mt-2">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :page-size="pageSize"
                    @current-change="handleCurrentChange"
                  >
                    <!-- :current-page.sync="currentPage4" -->
                  </el-pagination>
                </div>
                <!-- Pagination -->
              </div>
            </div>
            <p v-else class="text-center p-3 text-sm w-full bg-gray-100">
              No Training found
            </p>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <review-training
      :showReviewTraining="showReviewTraining"
      @close="showReviewTraining = false"
      :approvalEntries="approvalEntries"
      :trainingDetails="trainingDetails"
    ></review-training>
    <EditTrainingRequest
      :approvers="approvers"
      :info="requestToEdit"
      :refresh="refresh"
      :close="close"
      :show-edit-training-request="showEditRequest"
      @close="showEditRequest = false"
    ></EditTrainingRequest>
    <updateTrainingProgress
      :showTrainingProgressModal="showTrainingProgressModal"
      :close="close"
      :training="training"
      :currentProgress="currentProgress"
    ></updateTrainingProgress>
  </div>
</template>

<script>
import requestTraining from "./requestTraining.vue";
// import EditTraining from "./editTimeoff.vue";
import ReviewTraining from "./reviewTraining.vue";
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import { Tabs, TabPane } from "element-ui";
import updateTrainingProgress from "@/components/employees/modals/updateTrainingProgress";
import decryptData from "@/utils/decrypt";

import { mapGetters } from "vuex";
import moment from "moment";
import EditTrainingRequest from "./editTrainingRequest.vue";
import { formatCurrency } from "@/utils/currencyFomatter";
export default {
  name: "MyTraining",
  props: ["showDetails"],
  components: {
    requestTraining,
    // AttachmentsViewer,
    "el-tabs": Tabs,
    "el-tab-pane": TabPane,
    Loader,
    // EditTraining,
    ReviewTraining,
    updateTrainingProgress,
    EditTrainingRequest,
  },
  data() {
    return {
      showTrainingProgressModal: false,
      showEditTrainingRequest: false,
      approvedTrainings: [],
      pendingTrainings: [],
      canceledTrainings: [],
      ongoingTrainings: [],
      attachmentUrl: "",
      showRequestTraining: false,
      approvers: [],
      showAttachments: false,
      showReviewTraining: false,
      approvalEntries: null,
      trainingDetails: null,
      success: null,
      showEditRequest: false,
      requestToEdit: null,
      create_success: null,
      create_error: null,
      loading: false,
      reload: false,
      MyLeaveTypes: [],
      activeLabel: "",
      currentTab: "Approved",
      selectedTab: "",
      searchInput2: "",
      filteredTrainingHistories: [],
      searchInput: "",
      MyLeaveTypeStats: [],
      activeTab: 0,
      cancel_error: null,
      cancel_success: null,
      pageIndex: 1,
      pageSize: 10,
      pageSizes: [],
      training: null,
      currentProgress:"",
      // body row event custom
      eventCustomOption: {
        bodyRowEvents: ({ row }) => {
          return {
            click: (event) => {
              if (!(event.target instanceof SVGSVGElement)) {
                this.showDetails(row);
              }
            },
            dblclick: () => {
              if (!(event.target instanceof SVGSVGElement)) {
                this.showDetails(row);
              }
            },
            contextmenu: () => {},
            mouseenter: () => {},
            mouseleave: () => {},
          };
        },
      },

      tabs: [
        {
          name: "Approved",
          route: "mine-approved",
        },
        {
          name: "Ongoing",
          route: "team",
        },
        {
          name: "Completed",
          route: "mine",
        },
        {
          name: "Canceled",
          route: "mine-canceled",
        },
      ],

      balancesColumns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "Name",
          title: "Name",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "Days",
          key: "Days",
          title: "Days",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) =>
            row.Days > 0 ? (
              <p class="text-green-500 font-bold text-sm">{row.Days}</p>
            ) : (
              <p class="text-red-500 font-bold text-sm">{row.Days}</p>
            ),
        },
      ],

      balances: [],

      canceledAndDeclinedLeaves: [],
      // Work on this
      expandOption: {
        trigger: "row",
        render: ({ row }) => {
          return (
            <table class="table-auto w-full p-2">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Line Manager</th>
                </tr>
              </thead>
              <tbody>
                {row.map((row) => {
                  row;
                  return (
                    <tr class="text-center">
                      <td>Description</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          );
        },
        beforeExpandRowChange: ({ row, rowIndex }) => {
          // alert(JSON.stringify(row, rowIndex));
          this.getDepartments(row.Id, rowIndex);
        },
      },
      // Work on this

      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "x",
          title: "Name",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "StartDate",
          key: "a",
          title: "From",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="text-left">{this.formatDate(row.StartDate)}</p>
          ),
        },
        {
          field: "EndDate",
          key: "b",
          title: "To",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="text-left">{this.formatDate(row.EndDate)}</p>
          ),
        },
        {
          field: "Urgency",
          key: "urgency",
          title: "Urgency",
          renderBodyCell: ({ row }) => {
            let status = "";

            switch (row.Urgency) {
              case "Mild":
                status = (
                  <p class="cursor-pointer rounded bg-green-100 text-green-500">
                    {" "}
                    {row.Urgency}
                  </p>
                );
                break;

              case "Trivial":
                status = (
                  <p class="cursor-pointer rounded bg-blue-100 text-blue-500">
                    {row.Urgency}
                  </p>
                );
                break;
              case "Urgent":
                status = (
                  <p class="cursor-pointer bg-red-100 rounded text-red-500">
                    {row.Urgency}
                  </p>
                );
                break;
            }
            return status;
          },
        },
        {
          field: "Cost",
          key: "Cost",
          title: "Cost",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => (
            <p class="text-center">{formatCurrency(row.Cost)}</p>
          ),
        },
        {
          field: "Source",
          key: "source",
          title: "Source",
          ellipsis: {
            showTitle: true,
          },

          renderBodyCell: ({ row }) => {
            const urlPattern =
              /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/;

            if (urlPattern.test(row.Source)) {
              return (
                <a class="text-blue-900" href={row.Source} target="_blank">
                  <el-popover
                    placement="top-start"
                    title={"Training request from " + row.Name}
                    width="300"
                    trigger="hover"
                    content={row.Source}
                  >
                    <p
                      slot="reference"
                      class="cursor-pointer"
                      styel="font-size: 0.68rem !important;"
                    >
                      {row.Source}
                    </p>
                  </el-popover>
                </a>
              );
            } else {
              return (
                <el-popover
                  placement="top-start"
                  title={"Training request from " + row.Name}
                  width="300"
                  trigger="hover"
                  content={row.Source}
                >
                  <p
                    slot="reference"
                    class="cursor-pointer"
                    styel="font-size: 0.68rem !important;"
                  >
                    {row.Source}
                  </p>
                </el-popover>
              );
            }
          },
        },
        {
          field: "CreatedBy",
          key: "createdBy",
          title: "Created By",
          headerAlign: "left",
          align: "left",

          ellipsis: {
            showTitle: true,
          },

          renderBodyCell: ({ row }) => {
            return (
              <el-popover
                placement="top-start"
                title={"Training request from " + row.Name}
                width="300"
                trigger="hover"
                content={decryptData(row.CreatedBy, this.$decryptionKey)}
              >
                <p
                  slot="reference"
                  class="cursor-pointer"
                  styel="font-size: 0.68rem !important;"
                >
                  {decryptData(row.CreatedBy, this.$decryptionKey)}
                </p>
              </el-popover>
            );
          },
        },

        {
          field: "ApprovedBy",
          key: "approvedBy",
          title: "Approver",
          headerAlign: "left",
          align: "left",
          ellipsis: {
            showTitle: true,
          },

          renderBodyCell: ({ row }) => {
            return (
              <el-popover
                placement="top-start"
                title={"Training approved by " + row.Name}
                width="300"
                trigger="hover"
                content={decryptData(row.ApprovedBy, this.$decryptionKey)}
              >
                <p
                  slot="reference"
                  class="cursor-pointer"
                  styel="font-size: 0.68rem !important;"
                >
                  {decryptData(row.ApprovedBy, this.$decryptionKey)}
                </p>
              </el-popover>
            );
          },
        },
        {
          field: "Progress",
          key: "Progress",
          title: "Progress",
          headerAlign: "left",

          renderBodyCell: ({ row }) => {
            let status = "";

            switch (row.Progress) {
              case "Completed":
                status = (
                  <p class="cursor-pointer rounded bg-green-100 text-green-500">
                    {row.Progress.split(/(?=[A-Z])/).join(" ")}
                  </p>
                );
                break;

              case "InProgress":
                status = (
                  <p class="cursor-pointer rounded bg-blue-100 text-blue-500">
                    {row.Progress.split(/(?=[A-Z])/).join(" ")}
                  </p>
                );
                break;
              case "NotStarted":
                status = (
                  <p class="cursor-pointer rounded bg-red-100 text-red-500">
                    {row.Progress.split(/(?=[A-Z])/).join(" ")}
                  </p>
                );
                break;
            }
            return status;
          },
        },
        {
          field: "Description",
          key: "d",
          title: "Description",
          headerAlign: "left",
          align: "left",
          width: 150,
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={"Training request from " + row.Name}
              width="300"
              trigger="hover"
              content={row.Description}
            >
              <p
                slot="reference"
                class="cursor-pointer"
                styel="font-size: 0.68rem !important;"
              >
                {row.Description}
              </p>
            </el-popover>
          ),
        },

        {
          field: "Status",
          key: "g",
          title: "Status",
          renderBodyCell: ({ row }) => {
            let status = "";

            switch (row.Status) {
              case "Approved":
                status = (
                  <p class="cursor-pointer rounded bg-green-100 text-green-500">
                    {row.Status}
                  </p>
                );
                break;

              case "Pending":
                status = (
                  <p class="cursor-pointer rounded bg-blue-100 text-blue-500">
                    {row.Status}
                  </p>
                );
                break;
              case "Declined":
                status = (
                  <p class="cursor-pointer rounded bg-red-100 text-red-500">
                    {row.Status}
                  </p>
                );
                break;
            }
            return status;
          },
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 mt-5 px-2 hover:bg-primary hover:text-white"
                  style="border-radius: 0 !important"
                  onClick={() => {
                    this.showDetails(row);
                  }}
                >
                  View
                </button>
                {/*  <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="border-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="border-radius: 0 !important"
                  onClick={() => this.handleCancelButtonClick(row)}
                >
                  Cancel
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="border-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>*/}
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="border-radius: 0 !important"
                  onClick={() => this.handleUpdateProgresButtonClick(row)}
                >
                  Update Progress
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],
      columns2: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "TrainingName",
          key: "x",
          title: "Training",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "StartDate",
          key: "a",
          title: "From",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="">{this.formatDate(row?.StartDate)}</p>
          ),
        },
        {
          field: "EndDate",
          key: "b",
          title: "To",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="">{this.formatDate(row?.EndDate)}</p>
          ),
        },
        { field: "Urgency", key: "Urgency", title: "Urgency" },
        { field: "TrainingLink", key: "TrainingLink", title: "TrainingLink" },
        { field: "TrainingCost", key: "TrainingCost", title: "TrainingCost" },

        {
          field: "Description",
          key: "d",
          title: "Description",
          headerAlign: "left",
          align: "left",
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={"Training request from " + row.Name}
              width="300"
              trigger="hover"
              content={row.Description}
            >
              <p
                slot="reference"
                class="cursor-pointer"
                styel="font-size: 0.68rem !important;"
              >
                {row.Description}
              </p>
            </el-popover>
          ),
        },

        {
          field: "Reason",
          key: "dd",
          title: "Reason",
          headerAlign: "left",
          align: "left",
        },

        {
          field: "TrainingAttachment",
          key: "f",
          title: "Attachment",
          renderBodyCell: ({ row }) => {
            return (
              <button
                onClick={() => {
                  //console.log(row)

                  this.approvalEntries = row.ApprovalEntries;
                  this.trainingDetails = row;
                  this.showReviewTraining = true;
                }}
                class="bg-primary text-white rounded-full px-3 py-1 text-sm"
              >
                &#128206; View
              </button>
            );
          },
        },
        {
          field: "Status",
          key: "e",
          title: "Status",
          renderBodyCell: ({ row }) => {
            let status = "";
            switch (row.Status) {
              case "Approved":
                status = (
                  <p class="cursor-pointer text-green-500"> {row.Status}</p>
                );
                break;

              case "Pending":
                status = (
                  <p
                    class="cursor-pointer text-blue-500"
                    v-if={row.Status === "Pending"}
                  >
                    {row.Status}
                  </p>
                );
                break;
              case "Declined":
                status = (
                  <p
                    class="cursor-pointer text-red-500"
                    v-if={row.Status === "Declined"}
                  >
                    {row.Status}
                  </p>
                );
                break;
            }
            return <div> {status}</div>;
          },
        },
      ],
      tableData: [],
    };
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getUserType",
      "getCurrentEmployeeId",
      "getVersion",
    ]),

    filteredColumns() {
      const approvedCount = this.leaves.filter(
        (leave) => leave.Status === "Approved"
      ).length;
      const declinedCount = this.leaves.filter(
        (leave) => leave.Status === "Declined"
      ).length;

      return this.columns.filter((column) => {
        if (
          column.field === "Action" &&
          (approvedCount === this.leaves.length ||
            declinedCount === this.leaves.length)
        ) {
          return false;
        }
        return true;
      });
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },

  created() {
    this.getApprovers();
    decryptData(
      "xfVV3XysDRY08fF/aOYwc8m7chcl9Aehz6t9IGMiljDsue3nRj+I5LU5t+jblq9y",
      "wnqBZMCcl/GxLnF3hoOtkCs8PPQsosjh3eeiYOMgZZY="
    );

    this.updateTrainingList(this.currentTab);
    this.getMyTrainings(this.currentTab);
    this.setPageSizes();
    this.searchInput2 = this.activeLabel;
    this.setTab("pane-0");

    // Call the method to fetch data for the "Approved" tab
    this.fetchApprovedTabData();
  },

  methods: {
    handleUpdateProgresButtonClick(training) {
      this.training = training.TrainingId
      this.currentProgress = training.Progress
      this.showTrainingProgressModal = true;
    },

    close() {
      this.showTrainingProgressModal = false;
      this.showEditRequest = false;
    },

    getApprovers() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
          "Content-Type": "applicaion/json",
        },
      };

      axios
        .get(
          `${this.getOrganization}/training/approvers/${this.$ApiVersion}/request`,

          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.approvers = response.data.Data;
              console.log(response.data.Data, "Approvers")
              this.loading = false;
            } else {
              this.create_error = response.data.StatusMessage;
              this.$notify.error({
                title: "Success",
                message: response.data.StatusMessage,
              });
              this.loading = false;
              setTimeout(() => {
                this.create_error = null;
              }, 1500);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;

            this.$notify.error({
              title: "Success",
              message: error.message,
            });
            setTimeout(() => {
              this.create_error = null;
            }, 1500);
          }
        );
    },
    async fetchApprovedTabData() {
      this.getMyTrainings(this.currentTab);
      this.setTab("pane-0");
    },

    trainingRequestCallback(message, isSuccess) {
      if (isSuccess) {
        this.create_success = message;
      } else {
        this.create_error = message;
      }
      setTimeout(() => {
        this.cancel_error = null;
        this.create_success = null;
      }, 2000);
    },
    isSubmitted() {
      this.showEditRequest = false;
      this.getMyTrainings(this.currentTab);
    },
    refresh() {
      this.updateTrainingList(this.selectedTab);
      this.getMyTrainings(this.currentTab);
      this.setPageSizes();
      this.searchInput2 = this.activeLabel;
    },
    setTab(event) {
      let tabId;

      if (event["$el"]) {
        const { id } = event["$el"];
        tabId = id;
      } else {
        tabId = event;
      }

      switch (tabId) {
        case "pane-0":
        case "pane-Approved":
          this.selectedTab = "Approved";
          this.updateTrainingList("Approved");
          break;
        case "pane-1":
        case "pane-Ongoing":
          this.selectedTab = "Ongoing";
          this.updateTrainingList("Ongoing");
          break;
        case "pane-2":
        case "pane-Completed":
          this.selectedTab = "Completed";
          this.updateTrainingList("Completed");
          break;

        case "pane-3":
        case "pane-Canceled":
          this.selectedTab = "Canceled";
          this.updateTrainingList("Canceled");
          break;
      }
    },

    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleEditButtonClick(request) {
      // Handle the button click for the edit button
      this.requestToEdit = {
        ...request,
        Approver: decryptData(request.ApprovedBy, this.$decryptionKey),
        StartDate: moment(request.StartDate).format("YYYY-MM-DD"), // override StartDate with formatted value
        EndDate: moment(request.EndDate).format("YYYY-MM-DD"), // override EndDate with formatted value
      };

      this.showEditRequest = true;
    },

    async handleDeleteButtonClick(training) {
      if (await this.openWarning(training.Name)) {
        this.handleDelete(training);
      }
    },

    async openWarning(trainingName) {
      try {
        await this.$confirm(
          `This will permanently delete ${trainingName} from the trainings. Continue?`,
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        );
        return true;
      } catch {
        return false;
      }
    },
    async handleCancelButtonClick(row) {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json", // Set the content type to multipart form data
        },
        data: {
          TimeoffRequestId: row.Id,
        },
      };

      try {
        const response = await axios.delete(
          `${this.getOrganization}/timeoff/${this.$ApiVersion}/cancel`,
          options
        );

        this.loading = true;
        if (response.data.StatusCode === 200) {
          this.loading = false;
          this.cancel_success = response.data.StatusMessage;
          this.refresh();
          setTimeout(() => {
            this.cancel_success = null;
          }, 2000);
        } else {
          this.loading = false;
          this.cancel_error = response.data.StatusMessage;
          setTimeout(() => {
            this.cancel_error = null;
          }, 2000);
        }
      } catch (error) {
        this.loading = false;
        this.cancel_error = error.message;
        setTimeout(() => {
          this.cancel_error = null;
        }, 2000);
      }
    },
    // /{organization}/training/v1/delete
    async handleDelete({ TrainingId }) {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
        data: {
          TrainingId,
        },
      };

      try {
        const response = await axios.delete(
          `${this.getOrganization}/training/${this.$ApiVersion}/delete`,
          options
        );

        this.loading = true;
        if (response.data.StatusCode === 200) {
          this.loading = false;

          this.$notify({
            title: "Success",
            message: response.data.StatusMessage,
            type: "success",
          });
          this.refresh();
        } else {
          this.loading = false;

          this.$notify({
            title: "Failure",
            message: response.data.StatusMessage,
            type: "error",
          });
        }
      } catch (error) {
        this.loading = false;

        this.$notify({
          title: "Failure",
          message: error.message,
          type: "error",
        });
      }
    },

    formatDate(dateStr) {
      return moment(dateStr).format("DD/MM/YYYY");
    },
    getMyTrainings() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };
      // /{organization}/training/mine/v1/query
      axios
        .get(
          `${this.getOrganization}/training/mine/${this.$ApiVersion}/query`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.approvedTrainings = response.data.Data.filter(
                (training) => training.Status === "Approved"
              ).sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate));
              console.log(this.approvedTrainings);
              this.pendingTrainings = response.data.Data.filter(
                (training) => training.Status === "Pending"
              ).sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate));

              this.canceledTrainings = response.data.Data.filter(
                (training) => training.Status === "Canceled"
              ).sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate));

              this.ongoingTrainings = response.data.Data.filter(
                (training) => training.Status === "Ongoing"
              ).sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate));

              this.completedTrainings = response.data.Data.filter(
                (training) => training.Status === "Completed"
              ).sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate));
              this.updateTrainingList("Approved");
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    updateTrainingList(currentTab) {
      switch (currentTab) {
        case "Approved":
          this.selectedTab = "Approved";
          this.filteredTrainingHistories = this.approvedTrainings;
          break;
        case "Ongoing":
          this.selectedTab = "Ongoing";
          this.filteredTrainingHistories = this.ongoingTrainings;
          break;
        case "Completed":
          this.selectedTab = "Completed";
          this.filteredTrainingHistories = this.completedTrainings;
          break;

        case "Canceled":
          this.selectedTab = "Canceled";
          this.filteredTrainingHistories = this.canceledTrainings;
          break;
      }
    },
  },
};
</script>

<style>
.el-tabs__item.is-top.is-active {
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
  color: "#fff" !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #fff;
}

.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: #fff;
}

.el-tabs__item.is-top:hover {
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
}
</style>
